import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  link: {
    textDecoration: "none",
    padding: "0%",
    "&:hover, &:focus": {
      backgroundColor: "none",
    },
  },
  externalLink: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textDecoration: "none",
  },
  linkActive: {
    // backgroundColor: theme.palette.background.light,
    backgroundColor: "#d1e0f5",
    "&:hover, &:focus": {
      backgroundColor: "#d1e0f5",
    },
  },
  linkNested: {
    paddingLeft: 0,
    "&:hover, &:focus": {
      backgroundColor: theme.palette.background.light,
    },
  },
  subMenulinkIcon: {
    minWidth: "39px !important",
  },
  linkIcon: {
    //padding: "8% 50%",
    //  marginRight: theme.spacing(1),
    color: theme.palette.text.secondary,
    transition: theme.transitions.create("color"),
    width: 24,
    display: "flex",
    justifyContent: "center",
  },
  linkIconActive: {
    //backgroundColor: theme.palette.background.light,
    backgroundColor: "#d1e0f5",
  },
  linkText: {
    padding: 0,
    color: theme.palette.text.secondary,
    transition: theme.transitions.create(["opacity", "color"]),
    fontSize: 14,
    // textWrap:"wrap",
  },
  linkTextActive: {
    color: theme.palette.text.primary,
    backgroundColor: "#d1e0f5",
    lineHeight: "3.6",
    [theme.breakpoints.down("sm")]: {
      lineHeight: "3.9 !important",
    },
  },
  linkTextHidden: {
    opacity: 0,
  },
  nestedList: {
    paddingLeft: theme.spacing(2) + 30,
  },
  sectionTitle: {
    marginLeft: theme.spacing(4.5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    height: 1,
    backgroundColor: "#D8D8D880",
  },
  settingMenuBar: {
    marginLeft: "50px",
    boxShadow: "6px 4px 5px 0px rgba(100,138,137,1)",
  },

  sidedropdown: {
    cursor: "pointer",
    position: "fixed",
    left: "75px",
    backgroundColor: "white",
    boxShadow:
      "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
    top: "15%",
    zIndex: "999",
  },

  sidedropdown1: {
    //   cursor: "pointer",
    //   outline: 0,
    //   position: "fixed",
    //   overflowX: "hidden",
    //   overflowY: "auto",
    //     bottom: "40px",
    //  // top: "85%",
    //   left: "75px",
    //   zIndex:"999",
    //   backgroundColor:"white",
    //   boxShadow: "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",

    cursor: "pointer",
    position: "fixed",
    left: "75px",
    backgroundColor: "white",
    boxShadow:
      "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
    marginTop: "-70px",
    zIndex: "999",
    [theme.breakpoints.down("xs")]: {
      marginTop: "-150px",
    },
  },

  sidedropdown2: {
    cursor: "pointer",
    position: "fixed",
    left: "75px",
    bottom: "20px",
    backgroundColor: "white",
    boxShadow:
      "0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)",
    zIndex: "999",
  },

  sidedropdownList: {
    margin: "0px 10px 0px 0px",
    padding: "2px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#e0e0e0",
      color: "#000000",
      "& $subMenulinkIcon": {
        "& button": {
          color: "inherit",
        },
      },
      "& $linkText": {
        color: "inherit",
      },
    },
    "&.Mui-selected": {
      backgroundColor: "#e0e0e0 !important", // Background color when selected (primary color)
      color: "#000000",
      "&:hover": {
        backgroundColor: "#e0e0e0 !important",
        color: "#000000",
      },
    },
  },
}));
